import React from 'react';
import cls from './ToolsListHeader.module.scss';

const ToolsListHeader = () => {
  return (
    <div className={cls.Header}>
      <span className={cls.Item}>Name</span>
      <span className={cls.Item}>Description</span>
      <span className={cls.Item}>Status</span>
    </div>
  );
};

export default ToolsListHeader;
